<template>
  <resource-loader-controller
    :resource="schemaResource || listResource"
    v-slot="schemaProps"
  >
    <resource-loader-controller
      :resource="listResource"
      v-slot="allProps"
    >
      <resource-loader-controller
        :resource="availableResource"
        v-slot="availableProps"
      >
        <search-filter
          :value="filters"
          :permanent="permanent"
          @input="changeFilters"
          :schemaProps="schemaProps"
          :has-schema-resource="!!schemaResource"
          :allProps="allProps"
          :availableProps="availableProps"
          v-bind="$attrs"
        />
      </resource-loader-controller>
    </resource-loader-controller>
  </resource-loader-controller>
</template>

<script>
import SearchFilter from './View';

export default {
  props: [
    'filters',
    'schemaResource',
    'availableResource',
    'listResource',
    'permanent',
  ],

  components: {
    SearchFilter,
  },

  methods: {
    changeFilters(value) {
      this.$emit('update:filters', value);
    },
  },
};
</script>